import { singleton, autoinject } from "aurelia-framework";
import { BusyService } from "../services/busy-service";
import { WebApiService } from "../services/web-api-service";
import { TaskAssignmentGroups } from "../data/typegen/enums/task-assignment-groups";

@singleton()
@autoinject()
export class AlphabetAssignment {
    users: any;
    transloaderUsers: any;

    constructor(
        private busyService: BusyService,
        private api: WebApiService) {
    }


    async activate(params) {
        await this.refresh();
    }

    public segments: any[] = [];

    async loadSegments() {

        this.busyService.on();
        return this.api.get("Auth", "GetAlphabetAssignments")
            .then((result) => {
                const u = JSON.parse(result.response);
                this.segments = u;
            })
            .finally(() => this.busyService.off());

    }

    async loadUsers() {
        this.busyService.on();
        // TODO: Use taskController.GetGroupMembers instead
        var p1 = this.api.get("Auth", "GetAssignmentGroupUsers", { assignmentGroupId: TaskAssignmentGroups.carrierServices })
            .then((result) => {
                const u = JSON.parse(result.response);
                this.users = u.map(o => {
                    return { displayValue: o.firstName + ' ' + o.lastName, value: o.id };
                })
            })
            .finally(() => this.busyService.off());

        this.busyService.on();
        // TODO: Use taskController.GetGroupMembers instead
        var p2 = this.api.get("Auth", "GetAssignmentGroupUsers", { assignmentGroupId: TaskAssignmentGroups.transloaderServices })
            .then((result) => {
                const u = JSON.parse(result.response);
                this.transloaderUsers = u.map(o => {
                    return { displayValue: o.firstName + ' ' + o.lastName, value: o.id };
                })
            })
            .finally(() => this.busyService.off());

        await Promise.all([p1, p2]);

    }

    save() {

        // check all for blanks
        if (this.segments.find(o => !o.assignmentUserId)) {
            alert("Ensure that all selections have a valid user selected");
            return;
        }

        this.busyService.on();
        return this.api.post("Auth", "UpdateAlphabetAssignments", this.segments)
            .finally(() => this.busyService.off());
    }

    async refresh() {
        await this.loadUsers();
        await this.loadSegments();
    }



}
